import React, { useState } from 'react';
import { Calendar as CalendarIcon, Clock } from 'lucide-react';
import { Input } from './ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Calendar } from './ui/calendar';
import { format } from 'date-fns';
import { useToast } from '../hooks/use-toast';
import { laundryTypes, BRAND } from '../mock';

const TIMES = ['08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00'];

const ReservationForm = ({ compact = false }) => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: '', address: '', whatsapp: '', type: '', time: '' });
  const [date, setDate] = useState(null);

  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target?.value ?? e });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.whatsapp || !form.type) {
      toast({ title: 'Lengkapi form', description: 'Nama, Whatsapp, dan Jenis Laundry wajib diisi.' });
      return;
    }
    const msg = encodeURIComponent(
      `Halo Trust Me Laundry, saya ingin reservasi:%0A%0ANama: ${form.name}%0AAlamat: ${form.address}%0AWhatsapp: ${form.whatsapp}%0AJenis: ${form.type}%0ATanggal: ${date ? format(date, 'dd MMM yyyy') : '-'}%0AJam: ${form.time || '-'}`
    );
    window.open(`${BRAND.whatsapp}?text=${msg}`, '_blank');
    toast({ title: 'Reservasi terkirim!', description: 'Anda akan dialihkan ke WhatsApp untuk konfirmasi.' });
  };

  return (
    <form onSubmit={submit} className={`bg-white rounded-2xl shadow-2xl border border-[color:var(--brand-50)] p-6 lg:p-7 ${compact ? '' : 'relative'}`}>
      <div className="flex items-center justify-between mb-5">
        <div>
          <span className="inline-block px-2.5 py-0.5 rounded-full bg-[color:var(--brand-50)] text-[color:var(--brand)] text-[10px] font-semibold tracking-wider uppercase">Reservasi</span>
          <h3 className="font-display text-xl font-bold text-[color:var(--ink)] mt-1.5">Pickup Laundry</h3>
        </div>
        <div className="hidden md:flex h-10 w-10 rounded-full bg-[color:var(--brand-50)] items-center justify-center text-[color:var(--brand)] font-bold">TM</div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <Input placeholder="Nama" value={form.name} onChange={onChange('name')} className="h-11 rounded-lg" />
        <Input placeholder="Whatsapp" value={form.whatsapp} onChange={onChange('whatsapp')} className="h-11 rounded-lg" />
        <Input placeholder="Alamat" value={form.address} onChange={onChange('address')} className="h-11 rounded-lg md:col-span-2" />

        <Select value={form.type} onValueChange={(v) => setForm({ ...form, type: v })}>
          <SelectTrigger className="h-11 rounded-lg"><SelectValue placeholder="Jenis Laundry" /></SelectTrigger>
          <SelectContent>
            {laundryTypes.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
          </SelectContent>
        </Select>

        <Select value={form.time} onValueChange={(v) => setForm({ ...form, time: v })}>
          <SelectTrigger className="h-11 rounded-lg">
            <div className="flex items-center gap-2"><Clock className="w-4 h-4 text-[color:var(--brand)]" /><SelectValue placeholder="Jam Penjemputan" /></div>
          </SelectTrigger>
          <SelectContent>
            {TIMES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
          </SelectContent>
        </Select>

        <Popover>
          <PopoverTrigger asChild>
            <button type="button" className="h-11 rounded-lg border border-input bg-white px-3 flex items-center gap-2 text-sm text-left md:col-span-2 hover:border-[color:var(--brand)] transition-colors">
              <CalendarIcon className="w-4 h-4 text-[color:var(--brand)]" />
              <span className={date ? 'text-[color:var(--ink)]' : 'text-muted-foreground'}>
                {date ? format(date, 'EEEE, dd MMM yyyy') : 'Tanggal Penjemputan'}
              </span>
            </button>
          </PopoverTrigger>
          <PopoverContent className="p-0 w-auto" align="start">
            <Calendar mode="single" selected={date} onSelect={setDate} initialFocus />
          </PopoverContent>
        </Popover>
      </div>

      <button type="submit" className="btn-brand w-full mt-5 h-12 text-base">Pickup Sekarang</button>
      <p className="text-xs text-[color:var(--muted)] mt-3 text-center">Dengan mengirim reservasi, Anda akan terhubung dengan CS kami via WhatsApp.</p>
    </form>
  );
};

export default ReservationForm;
